import React from "react";
import { Navbar } from "../../Navbar/Navbar";
import { Outlet } from "react-router-dom";
import { useGetInitialAppliedThemeQuery } from "../../../redux-toolkit/features/theme/themeApiSlice";
import ProgressBar from "../../UI/ProgressBar";
import { useGetBookByIdQuery } from "../../../redux-toolkit/features/books/bookApiSlice";
import { useParams } from "react-router-dom";
import "./MainBookLayout.css";
import { ThemeBackground } from "../ThemeBackground/ThemeBackground";

const MainBookLayout = () => {
  const { bookId } = useParams();
  const { isLoading } = useGetInitialAppliedThemeQuery({
    refetchOnMountOrArgChange: true,
  });
  const { data: bookData } = useGetBookByIdQuery(bookId, {
    skip: !bookId,
  });

  if (isLoading) {
    return (
      <div style={{ backgroundColor: "white", height: "100vh" }}>
        <ProgressBar />;
      </div>
    );
  }

  return (
    <ThemeBackground
      className="bookLayout__rel"
      src={bookData?.data?.theme?.bgImage}
      poster={bookData?.data?.theme?.themeCardImage}
      backgroundSize="100vw 100vh"
      backgroundAttachment="fixed"
      style={{ minHeight: "100vh" }}
    >
      {bookData?.data?.theme?.rightIcon != null && (
        <div
          className={
            bookData?.data?.name === "Wilderness Expedition"
              ? "bookLayout__rightJungle"
              : "bookLayout__right"
          }
        >
          <img src={bookData?.data?.theme?.rightIcon} alt="rightIcon" />
        </div>
      )}
      {bookData?.data?.theme?.rightIcon != null && (
        <div
          className={
            bookData?.data?.name === "Wilderness Expedition"
              ? "bookLayout__leftJungle"
              : "bookLayout__left"
          }
        >
          <img src={bookData?.data?.theme?.leftIcon} alt="leftIcon" />
        </div>
      )}
      <Navbar bookMode={bookData?.data?.theme?.mode} isBook />
      <Outlet />
    </ThemeBackground>
  );
};

export default MainBookLayout;
